module.exports = __webpack_public_path__ + "img/width-spline-icon.a819cc94.png";